import { createAction } from 'actions/utils';
import { GET_ROLES_REQUEST, GET_ROLES_SUCCESS, GET_ROLES_ERROR } from 'constants/ActionTypes';
import { Core } from 'managers';

export function getRoles() {
    return (dispatch) => {
        dispatch(createAction(GET_ROLES_REQUEST, {}));
        return Core.rolesManager.getRoles().then(
            (res) => {
                dispatch(createAction(GET_ROLES_SUCCESS, res));
            },
            (error) => {
                dispatch(createAction(GET_ROLES_ERROR, error));
                throw error;
            },
        );
    };
}
